import axios from 'axios'

export const GET_SERVER_VERSION_SUCCESS = 'GET_SERVER_VERSION_SUCCESS';
export const GET_SERVER_VERSION_ERROR = 'GET_SERVER_VERSION_ERROR';

export function getServerVersionSuccess(version) {
    return {
        type: GET_SERVER_VERSION_SUCCESS,
        version: version
    };
}

export function getServerVersionError() {
    return {
        type: GET_SERVER_VERSION_ERROR,
        version: null
    };
}

async function getData() {
    const res = await axios("/server_version");
    return res.data;
  }

export function fetchServerVersion() {
    return (dispatch) => {
        getData()
        .then(response => {
            dispatch(getServerVersionSuccess(response));
        })
        .catch(err => 
        {
            dispatch(getServerVersionError());
        })
        }
    }